module.exports = __webpack_public_path__ + "static/media/6.e1b49de7.jpg";